export const roleFilter = user => {
  return ({ role }) => {
    return !role || role === (user.isApprentice ? "employee" : "mentor");
  };
};
